<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết Leads</h1>
      <div class="btn-group float-right">
        <button class="f12 font-medium btn btn-outline-secondary" @click="backToList()">
          <i class="bx bx-arrow-back"></i> Quay lại
        </button>
        <button
          class="f12 font-medium btn btn-outline-secondary"
          v-if="
            ((dataPermission && dataPermission.includes('CNPS_LEAD_UPDATE')) ||
              dataUser.typeSale === 'SALE_DIRECTOR') &&
            dataLeads.status !== 'EXPIRED_SUPPORT' &&
            dataLeads.status !== 'USED_SERVICE'
          "
          @click="editLeads()"
        >
          <i class="bx bx-pencil"></i> Sửa
        </button>
        <button
          class="f12 font-medium btn btn-outline-secondary"
          v-if="
            isLead(dataLeads?.status) && ['NEW', 'NO_CARE', 'VERIFIED']?.includes(dataLeads.status)
          "
          @click="convertIntoCustomer()"
        >
          <i class="bx bx-user-plus"></i> Chuyển thành KH
        </button>
        <button
          class="f12 font-medium btn btn-outline-secondary"
          @click="openListDevice()"
          v-if="dataLeads?.customerId"
        >
          <i class="bx bxs-send"></i> Gửi TB cho MC nguồn CTV
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-12">
          <!-- <div class="alert alert-danger" role="alert">
            <p>A simple danger alert—check it out! </p>
          </div> -->
        </div>
        <div class="col-12">
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="ttc">
              <div class="form-row">
                <div class="col-sm-6">
                  <div class="form-detail">
                    <h1>1. Thông tin chung</h1>

                    <div class="form-group form-row" v-if="dataLeads.merchantName">
                      <label for="" class="col-sm-4 col-form-label"
                        >Tên cửa hàng<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataLeads.merchantName }}</p>
                      </div>
                    </div>

                    <div class="form-group form-row" v-if="dataLeads.customerName">
                      <label for="" class="col-sm-4 col-form-label"
                        >Tên người đại diện<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataLeads.customerName }}</p>
                      </div>
                    </div>

                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Địa chỉ<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          <span v-if="dataLeads.address && dataLeads.address !== null"
                            >{{ dataLeads.address }} -
                          </span>
                          <span v-if="dataLeads.district">{{ dataLeads.district }} - </span>
                          {{ dataLeads.city }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row" v-if="dataLeads.email">
                      <label for="" class="col-sm-4 col-form-label"
                        >Email<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataLeads.email }}</p>
                      </div>
                    </div>

                    <div class="form-group form-row" v-if="dataLeads.storeSignName">
                      <label for="" class="col-sm-4 col-form-label"
                        >Tên biển hiệu<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataLeads.storeSignName }}</p>
                      </div>
                    </div>

                    <div class="form-group form-row" v-if="dataLeads.mobile">
                      <label for="" class="col-sm-4 col-form-label"
                        >Số điện thoại<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataLeads.mobile }}</p>
                      </div>
                    </div>

                    <div class="form-group form-row" v-if="dataLeads.mcc">
                      <label for="" class="col-sm-4 col-form-label"
                        >Ngành nghề<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataLeads.mcc | transformData(systemConfig.businessFields) }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row" v-if="dataLeads.mcc">
                      <label for="" class="col-sm-4 col-form-label"
                        >Ngành nghề chi tiết<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataLeads.mccDetail }}</p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataLeads.mccDetail === 'Khác'">
                      <label for="" class="col-sm-4 col-form-label"
                        >Ngành nghề chi tiết(ghi chú thêm)<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataLeads.mccDetailOther }}</p>
                      </div>
                    </div>

                    <div class="form-group form-row" v-if="dataLeads.customerType">
                      <label for="" class="col-sm-4 col-form-label"
                        >Loại lead<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataLeads.customerType | fomatCustomtype }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row" v-if="dataLeads.status">
                      <label for="" class="col-sm-4 col-form-label"
                        >Trạng thái<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          <span
                            class="badge"
                            v-bind:class="[dataLeads.status ? dataLeads.status : '']"
                          >
                            {{ dataLeads.status | mapTextStatus(listState) }}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div
                      class="form-group form-row"
                      v-if="
                        dataLeads.channel &&
                        (dataLeads.channel === 'AGENCY' || dataLeads.channel === 'MARKETING')
                      "
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >Nguồn<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataLeads.channel | transformData(dataSource) }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row" v-if="dataLeads.channel === 'AGENCY'">
                      <label for="" class="col-sm-4 col-form-label"
                        >Công tác viên<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataLeads.agentName }} -
                          {{ dataLeads.agentEmail }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row" v-if="dataLeads.createdAt">
                      <label for="" class="col-sm-4 col-form-label"
                        >Thời gian tạo<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataLeads.createdAt | formatDate('HH:mm DD/MM/YYYY') }}
                        </p>
                      </div>
                    </div>

                    <div class="form-group form-row" v-if="dataLeads.modifiedAt">
                      <label for="" class="col-sm-4 col-form-label"
                        >Cập nhật<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataLeads.modifiedAt | formatDate('HH:mm DD/MM/YYYY') }}
                        </p>
                      </div>
                    </div>

                    <!-- <div class="form-group form-row" v-if="dataLeads.activeSaleName">
                      <label for="" class="col-sm-4 col-form-label">Sales chăm sóc<span class="float-right">:</span></label>
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataLeads.activeSaleName }} - {{ dataLeads.activeSaleEmail }}</p>
                      </div>
                    </div> -->

                    <div class="form-group form-row" v-if="dataLeads.rating">
                      <label for="" class="col-sm-4 col-form-label"
                        >Độ ưu tiên<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataLeads.rating | transformData(dataRating) }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataLeads.dataSource">
                      <label for="" class="col-sm-4 col-form-label"
                        >Kênh tạo<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataLeads.dataSource }}</p>
                      </div>
                    </div>

                    <div class="form-group form-row" v-if="dataLeads.description">
                      <label for="" class="col-sm-4 col-form-label"
                        >Ghi chú<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataLeads.description }}</p>
                      </div>
                    </div>

                    <div class="form-group form-row" v-if="dataLeads.reason">
                      <label for="" class="col-sm-4 col-form-label"
                        >Lý do thông tin sai<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">{{ dataLeads.reason }}</p>
                      </div>
                    </div>
                    <div class="form-group form-row">
                      <label for="" class="col-sm-4 col-form-label"
                        >Xếp hạng<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <span
                          v-if="dataLeads.tag && dataLeads.score > 0"
                          class="bage badge-pill rateLead"
                          ><span>{{ dataLeads.tag | transformData(Config.tagLead) }} :</span>
                          {{ dataLeads.score }}</span
                        >
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataLeads.customerType">
                      <label for="" class="col-sm-4 col-form-label"
                        >Loại hình<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataLeads.customerType | transformData(Config.customerType) }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataLeads.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Có GPDKKD không<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{
                            dataLeads.extraInfo.licenseBusiness
                              | transformData(systemConfig.licenseBusiness)
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataLeads.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Vị trí cửa hàng<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{
                            dataLeads.extraInfo.storeLocation
                              | transformData(systemConfig.storeLocation)
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataLeads.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Giá trị TB đơn hàng<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{
                            dataLeads.extraInfo.averageOrder
                              | transformData(systemConfig.averageOrder)
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataLeads.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Người mua hàng<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{
                            dataLeads.extraInfo.averageAge | transformData(systemConfig.averageAge)
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataLeads.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Số lượng cửa hàng<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataLeads.extraInfo.numberOfShop }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataLeads.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Số lượng nhân viên<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataLeads.extraInfo.numberOfStaff }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataLeads.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Người thu ngân<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataLeads.extraInfo.cashier | transformData(systemConfig.cashier) }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataLeads.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Tình trạng biển hiệu<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{
                            dataLeads.extraInfo.bannerState
                              | transformData(systemConfig.bannerState)
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataLeads.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Đã biết MPOS chưa<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataLeads.extraInfo.knowMPOS | transformData(systemConfig.knowMPOS) }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataLeads.suggestServiceList">
                      <label for="" class="col-sm-4 col-form-label"
                        >Dịch vụ quan tâm<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p
                          class="form-control-plaintext f12"
                          v-for="(item, index) in dataLeads.suggestServiceList"
                          :key="index"
                        >
                          {{ item.serviceType | transformData(systemConfig.services) }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="form-group form-row"
                      v-if="dataLeads.extraInfo && dataLeads.extraInfo.lstPaymentMethodSuggest"
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >PT Thanh toán quan tâm<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p
                          class="form-control-plaintext f12"
                          v-for="(item, index) in dataLeads.extraInfo.lstPaymentMethodSuggest"
                          :key="index"
                        >
                          {{ item | transformData(systemConfig.paymentMethod) }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataLeads.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Đã có POS chưa<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataLeads.extraInfo.ownPOS | transformData(systemConfig.ownPOS) }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="form-group form-row"
                      v-if="dataLeads.extraInfo && dataLeads.extraInfo.lstPos"
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >POS bên nào<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p
                          class="form-control-plaintext f12"
                          v-for="(item, index) in dataLeads.extraInfo.lstPos"
                          :key="index"
                        >
                          {{ item | transformData(systemConfig.posBank) }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="form-group form-row"
                      v-if="
                        dataLeads.extraInfo &&
                        dataLeads.extraInfo.lstPos &&
                        dataLeads?.extraInfo?.lstPos?.includes('OTHER')
                      "
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >POS bên nào (ghi chú thêm)<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataLeads.extraInfo.posOther }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataLeads.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Đã có VietQR chưa<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{
                            dataLeads.extraInfo.hasVietQr | transformData(systemConfig.hasVietQr)
                          }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="form-group form-row"
                      v-if="dataLeads.extraInfo && dataLeads.extraInfo.lstVietQrBank"
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >VietQR bên nào<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p
                          class="form-control-plaintext f12"
                          v-for="(item, index) in dataLeads.extraInfo.lstVietQrBank"
                          :key="index"
                        >
                          {{ item | transformData(systemConfig.vietQrBank) }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="form-group form-row"
                      v-if="
                        dataLeads?.extraInfo &&
                        dataLeads?.extraInfo?.lstVietQrBank &&
                        dataLeads?.extraInfo?.lstVietQrBank?.includes('OTHER')
                      "
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >VietQR bên nào(ghi chú thêm)<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataLeads.extraInfo.vietQrBankOther }}
                        </p>
                      </div>
                    </div>
                    <div class="form-group form-row" v-if="dataLeads.extraInfo">
                      <label for="" class="col-sm-4 col-form-label"
                        >Đã có Trả góp chưa<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{
                            dataLeads.extraInfo.hasInstallment
                              | transformData(systemConfig.hasInstallment)
                          }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="form-group form-row"
                      v-if="dataLeads.extraInfo && dataLeads.extraInfo.lstInstallmentBank"
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >Trả góp bên nào<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p
                          class="form-control-plaintext f12"
                          v-for="(item, index) in dataLeads.extraInfo.lstInstallmentBank"
                          :key="index"
                        >
                          {{ item | transformData(systemConfig.installmentBank) }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="form-group form-row"
                      v-if="
                        dataLeads?.extraInfo &&
                        dataLeads?.extraInfo?.lstInstallmentBank &&
                        dataLeads?.extraInfo?.lstInstallmentBank?.includes('OTHER')
                      "
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >Trả góp bên nào(ghi chú thêm)<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataLeads.extraInfo.installmentBankOther }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="form-group form-row"
                      v-if="dataLeads?.extraInfo && dataLeads?.extraInfo?.softwareUseState"
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >TT sử dụng PM quản lý<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{
                            dataLeads.extraInfo.softwareUseState
                              | transformData(systemConfig.softwareUseState)
                          }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="form-group form-row"
                      v-if="dataLeads?.extraInfo && dataLeads?.extraInfo?.storeManagementSoftware"
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >PM quản lý bên nào<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p
                          class="form-control-plaintext f12"
                          v-for="(item, index) in dataLeads?.extraInfo?.storeManagementSoftware"
                          :key="index"
                        >
                          {{ item | transformData(systemConfig?.storeManagementSoftware) }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="form-group form-row"
                      v-if="
                        dataLeads?.extraInfo &&
                        dataLeads?.extraInfo?.storeManagementSoftware &&
                        dataLeads?.extraInfo?.storeManagementSoftware?.includes('OTHER')
                      "
                    >
                      <label for="" class="col-sm-4 col-form-label"
                        >PM quản lý bên nào(ghi chú thêm)<span class="float-right">:</span></label
                      >
                      <div class="col-sm-8">
                        <p class="form-control-plaintext f12">
                          {{ dataLeads.extraInfo.storeManagementSoftwareOther }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="form-detail" v-if="dataLeads?.agentGroup?.includes('VCBHO')">
                    <h1>1.1 Thông tin Agent VCBHO</h1>
                    <div class="card-body">
                      <div class="form-group form-row">
                        <label for="" class="col-sm-4 col-form-label"
                          >Số điện thoại liên hệ<span class="float-right">:</span></label
                        >
                        <div class="col-sm-8">
                          <p class="form-control-plaintext f12">
                            {{ dataLeads?.contactPhoneNumber ?? '' }}
                          </p>
                        </div>
                      </div>

                      <div class="form-group form-row">
                        <label for="" class="col-sm-4 col-form-label"
                          >Thời gian giao hàng mong muốn<span class="float-right">:</span></label
                        >
                        <div class="col-sm-8">
                          <p class="form-control-plaintext f12">
                            {{ formatExpectedDeliveryTime }}
                          </p>
                        </div>
                      </div>

                      <div class="form-group form-row">
                        <label for="" class="col-sm-4 col-form-label"
                          >Số lượng máy<span class="float-right">:</span></label
                        >
                        <div class="col-sm-8">
                          <p class="form-control-plaintext f12">
                            {{ dataLeads.deviceQuantity ?? 0 }}
                          </p>
                        </div>
                      </div>

                      <div class="form-group form-row">
                        <label for="" class="col-sm-4 col-form-label"
                          >Hình thức bàn giao<span class="float-right">:</span></label
                        >
                        <div class="col-sm-8">
                          <p class="form-control-plaintext f12">
                            {{ handoverType[dataLeads.handoverType] ?? '' }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-detail">
                    <div class="d-flex justify-content-between">
                      <h1>2. Lịch sử thay đổi</h1>
                    </div>
                    <div class="table-responsive">
                      <table class="table table-hover table-bordered">
                        <thead class="thead-light">
                          <tr>
                            <th scope="col" class="text-center">Thời gian</th>
                            <th scope="col" class="text-center">Nhân viên tạo</th>
                            <th scope="col" class="text-center">Nhân viên tư vấn</th>
                            <th scope="col" class="text-center">Nhân viên triển khai</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            class="table-row"
                            v-for="(item, index) in dataLeads.assignHistoryLogs"
                            :key="index"
                          >
                            <td class="text-center">
                              {{ item.assignedAt | formatDate('HH:mm DD/MM/YYYY') }}
                            </td>
                            <td class="text-center">
                              <span v-if="item.createdByName">{{ item.createdByName }} - </span>
                              <span v-if="item.createdByMobile">{{ item.createdByMobile }} - </span>
                              <span v-if="item.createdByEmail">{{ item.createdByEmail }}</span>
                            </td>
                            <td class="text-center">
                              {{ item.teleSaleName }}
                              <span v-if="item.teleSaleEmail"> - {{ item.teleSaleEmail }} </span>
                            </td>
                            <td class="text-center">
                              {{ item.activeSaleName }}
                              <span v-if="item.activeSaleEmail">
                                - {{ item.activeSaleEmail }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-detail">
                    <div class="d-flex justify-content-between">
                      <h1>3. Lịch sử chăm sóc</h1>
                      <b-link
                        v-if="
                          dataLeads.status === 'NEW' ||
                          dataLeads.status === 'NO_CARE' ||
                          dataLeads.status === 'VERIFIED'
                        "
                        class="font-size-16"
                        @click="showModalAddAction()"
                      >
                        <i class="bx bx-plus-circle"></i> Thêm hoạt động
                      </b-link>
                    </div>
                    <div
                      class="table-responsive"
                      v-if="dataLeads.actionLogs && dataLeads.actionLogs.length"
                    >
                      <table
                        class="table table-hover table-bordered"
                        style="max-height: 400px; overflow-y: auto"
                      >
                        <thead class="thead-light">
                          <tr>
                            <th scope="col" class="text-center">TG thực hiện</th>
                            <th scope="col" class="text-center">Nội dung</th>
                            <th scope="col" class="text-center">Người thực hiện</th>
                            <th scope="col" class="text-center">Ảnh</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            class="table-row"
                            v-for="(item, index) in dataLeads.actionLogs"
                            :key="index"
                          >
                            <td class="text-center">
                              {{ item.historyCreatedAt | formatDate('HH:mm DD/MM/YYYY') }}
                            </td>
                            <td class="text-center">
                              <p>
                                <b-badge class="font-size-12" pill variant="primary" size="sm">
                                  <span v-if="item.historyAction === 'CALLED'"
                                    ><i class="bx bxs-phone"></i> Đã gọi điện</span
                                  >
                                  <span v-if="item.historyAction === 'SENT_MESS'"
                                    ><i class="bx bx-message-square-dots"></i> Đã nhắn tin</span
                                  >
                                  <span v-if="item.historyAction === 'SENT_MAIL'"
                                    ><i class="bx bx-mail-send"></i> Đã gửi email</span
                                  >
                                  <span v-if="item.historyAction === 'MET'"
                                    ><i class="bx bx-user"></i> Đã gặp mặt tư vấn</span
                                  >
                                  <span v-if="item.historyAction === 'OTHER'"
                                    ><i class="bx bxs-purchase-tag"></i> Việc khác</span
                                  >
                                </b-badge>
                              </p>
                              <p>
                                Kết quả:
                                <span
                                  class="badge"
                                  v-bind:class="[item.historyResult ? item.historyResult : '']"
                                >
                                  {{ item.historyResult | transformData(dataResultAction) }}
                                </span>
                              </p>
                              <p v-if="item.historyNote">Ghi chú: {{ item.historyNote }}</p>
                            </td>
                            <td class="text-center">{{ item.historyCreatedByName }}</td>
                            <td class="text-center">
                              <b-link
                                v-show="item.actionImgs && item.actionImgs.length > 0"
                                class="font-size-16"
                                @click="showActionImage(item)"
                              >
                                Xem ảnh
                              </b-link>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div
                    class="form-detail"
                    v-if="dataLeads.uploadImages && dataLeads.uploadImages.length"
                  >
                    <div class="img-list-wrapper">
                      <h1 class="form-inner-heading">4. Ảnh</h1>

                      <div class="form-group row img-list ml-2">
                        <ul v-viewer>
                          <li v-for="(itemImg, index) in dataLeads.uploadImages" :key="index">
                            <a href="#popup-slider" data-toggle="modal">
                              <img :src="itemImg" alt="" />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <DeviceShipments type="lead" :customerId="leadId" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Modal thông báo-->
    <b-modal id="modal-scoped" centered v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <button type="button" class="close" @click="close()">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" :alt="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>

    <b-modal centered v-model="modalBeforeAddAction">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <button type="button" class="close" @click="close()">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" :alt="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
        <b-button size="sm" variant="primary" @click="acceptAddAction()"> Đồng ý </b-button>
      </template>
    </b-modal>

    <reasonWrongInfo
      :showModalReasonWrongInfo="showModalReasonWrongInfo"
      @submitReject="submitReasonWrongInfo($event)"
      @closeModal="showModalReasonWrongInfo = false"
    >
      <slot></slot>
    </reasonWrongInfo>

    <b-modal id="modal-center" centered title="Thêm hoạt động" size="lg">
      <ValidationObserver ref="leadAction">
        <form>
          <ValidationProvider rules="required" vid="type" name="Hình thức">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-4 col-form-label"
                >Hình thức <span style="color: red">*</span></label
              >
              <div class="col-sm-8">
                <Select2
                  v-model="dataAddAction.type"
                  :options="dataTypeAction"
                  placeholder="Hình thức"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="required" vid="result" name="Kết quả">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-4 col-form-label"
                >Kết quả <span style="color: red">*</span></label
              >
              <div class="col-sm-8">
                <Select2
                  v-model="dataAddAction.result"
                  :options="dataResultAction"
                  placeholder="Kết quả"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="required" vid="actionTime" name="Thời gian thực hiện">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-4 col-form-label"
                >Thời gian thực hiện <span style="color: red">*</span></label
              >
              <div class="col-sm-8">
                <date-picker
                  format="dd/MM/yyyy"
                  v-model="dataAddAction.exeDate"
                  :config="optionsDatePicker"
                ></date-picker>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="name4" vid="note" name="Ghi chú">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-4 col-form-label">Ghi chú</label>
              <div class="col-sm-8">
                <input
                  v-model="dataAddAction.note"
                  type="text"
                  class="form-control"
                  placeholder="Ghi chú"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <div class="form-group row">
            <label for class="col-sm-4 col-form-label">Ảnh</label>
            <div class="col-sm-8">
              <addImagesWork @addImage="receiveImageToAdd" @removeImage="receiveImageToRemove">
              </addImagesWork>
            </div>
          </div>
        </form>
      </ValidationObserver>
      <div style="height: 10vh">
        <p v-if="paramAction === 'addActionFromOther' || checkNoteBeforeAddAction" class="mt-4">
          <i
            ><span style="color: red">*</span> Để chuyển thành KH vui lòng chọn Kết quả chăm sóc là
            Phù hợp trước</i
          >
        </p>
      </div>
      <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>

      <template #modal-footer="{}">
        <b-button variant="success" @click="checkAddAction()"> Lưu </b-button>
        <b-button @click="cancelAddAction()"> Huỷ </b-button>
      </template>
    </b-modal>

    <div v-if="showModalCheckAction">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalCheckAction = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img src="@/assets/img/noti-unsuccess2.svg" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messNoti }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="(showModalCheckAction = false), addAction()"
                    data-dismiss="modal"
                  >
                    Đồng ý
                  </button>
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="
                      (showModalCheckAction = false),
                        $bvModal.hide('modal-center'),
                        (dataAddAction = {})
                    "
                    data-dismiss="modal"
                  >
                    Không
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="showModalActionsImages">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Ảnh công việc</h5>
                  <button
                    type="button"
                    @click="showModalActionsImages = false"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div
                  class="modal-body d-flex justify-content-around align-items-center"
                  style="max-height: 500px; overflow: scroll"
                >
                  <div
                    class="form-group row w-40"
                    v-for="(item, index) in dataActionImage"
                    :key="index"
                  >
                    <li>
                      <a href="#popup-slider" data-toggle="modal">
                        <img :src="item" alt="" />
                      </a>
                    </li>
                  </div>
                </div>

                <div class="modal-footer">
                  <button
                    type="button"
                    @click="showModalActionsImages = false"
                    class="btn btn-light"
                  >
                    Đóng
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <PopupListDevice ref="listTbActiveRef" @onLoad="fetchData" />
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { LeadsService } from '@/services/lead.service'
  import reasonWrongInfo from './modal-leads/reason-wrong-info.vue'
  import { CommonService } from '@/services/common.service'

  import PopupListDevice from '@/components/common/PopupListDevice.vue'
  import datePicker from 'vue-bootstrap-datetimepicker'
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
  import addImagesWork from './modal-leads/add-images-work.vue'
  import Config from '@/thirdParty/config'
  import merchantMx from '../../mixins/merchantMx'
  import DeviceShipments from '@/components/common/DeviceShipments.vue'

  // Using font-awesome 5 icons
  import $ from 'jquery'
  $.extend(true, $.fn.datetimepicker.defaults, {
    icons: {
      time: 'far fa-clock',
      date: 'far fa-calendar',
      up: 'fas fa-arrow-up',
      down: 'fas fa-arrow-down',
      previous: 'fas fa-chevron-left',
      next: 'fas fa-chevron-right',
      today: 'fas fa-calendar-check',
      clear: 'far fa-trash-alt',
      close: 'far fa-times-circle',
    },
  })
  const handoverType = {
    OFFLINE: 'Offline',
    ONLINE: 'Online',
  }

  export default {
    mixins: [merchantMx],
    data() {
      return {
        leadId: this.$route.params.leadId,
        dataLeads: {},
        notiModal: false,
        iconNoti: '',
        msgNoti: '',
        checkShowMposTrans: false,
        dataInsert: {},
        checkCollectMoney: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        showModalReasonWrongInfo: false,
        dataSource: [{ id: '0', text: 'Tất cả' }, ...Config.sourceCreate],
        listState: Config.leadStatus,
        dataAddAction: {},
        dataTypeAction: [
          { id: 'MET', text: 'Đã gặp mặt tư vấn' },
          { id: 'CALLED', text: 'Đã gọi điện' },
          { id: 'SENT_MESS', text: 'Đã nhắn tin' },
          { id: 'SENT_MAIL', text: 'Đã gửi email' },
          { id: 'OTHER', text: 'Việc khác' },
        ],
        dataResultAction: [
          { id: 'SUITABLE', text: 'Phù hợp' },
          { id: 'MEET_FAIL', text: 'Không liên hệ được' },
          { id: 'NO_CARE', text: 'Chưa quan tâm' },
          { id: 'DUPLICATE', text: 'Trùng thông tin' },
          { id: 'WRONG', text: 'Sai thông tin' },
          { id: 'HAS_SERVICE', text: 'Đã sử dụng dịch vụ' },
          { id: 'OTHER', text: 'Khác' },
        ],
        showModalCheckAction: false,
        messNoti: '',

        modalBeforeAddAction: false,

        options: {
          defaultWidth: '100%',
          defaultHeight: '100%',
        },
        style: {
          width: '100%',
        },
        dataRating: [
          { id: 'HOT', text: 'Ưu tiên' },
          { id: 'WARM', text: 'Thường' },
          { id: 'COLD', text: 'Không ưu tiên' },
        ],
        optionsDatePicker: {
          format: 'YYYY-MM-DD HH:mm',
          useCurrent: true,
        },
        paramAction: this.$route.params.action,
        checkNoteBeforeAddAction: false,
        dataImages: [],
        dataImageToAdd: [],
        showLoading: false,
        showModalActionsImages: false,
        dataActionImage: [],
        Config,
        handoverType,
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      formatExpectedDeliveryTime() {
        return this.dataLeads?.expectedDeliveryTime
          ? this.$options.filters.formatDate(this.dataLeads.expectedDeliveryTime, 'DD/MM/YYYY')
          : ''
      },
    },

    components: {
      PopupListDevice,
      reasonWrongInfo,
      datePicker,
      addImagesWork,
      DeviceShipments,
    },

    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },

    created() {
      this.getConfigSystem()
      this.fetchData()
    },

    mounted() {
      this.checkActionBefore()
    },

    methods: {
      openListDevice() {
        this.$refs.listTbActiveRef.show(this.dataLeads?.customerId || '')
      },
      backToList() {
        this.$router.push('/leads')
      },
      checkActionBefore() {
        if (['addAction', 'addActionFromOther']?.includes(this.paramAction))
          this.$bvModal.show('modal-center')
      },
      editLeads() {
        if (
          [this.dataLeads?.createdBy, this.dataLeads?.activeSaleId]?.includes(
            this.dataUser.userId
          ) ||
          this.dataUser.typeSale === 'SALE_DIRECTOR'
        ) {
          this.$router.push(`/edit-lead/${this.dataLeads.leadId}`)
        } else {
          this.showErr('Bạn chỉ được sửa leads của mình')
        }
      },

      async fetchData() {
        try {
          const response = await LeadsService.detailLead({
            leadId: this.leadId,
          })
          if (response.code === 1000 || response.success) {
            this.dataLeads = response.data
          } else {
            this.showErr(response.message)
          }
        } catch (error) {
          this.showErr(error.response?.data?.message || error.response?.message || error.message)
        }
      },
      async convertIntoCustomer() {
        try {
          if ((this.dataLeads.actionLogs?.length || 0) === 0) {
            // this.modalBeforeAddAction = true
            // this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            // this.msgNoti = 'Bạn cần nhập hoạt động trước khi chuyển đổi thành Khách hàng !'
            // return
            this.checkNoteBeforeAddAction = true
            this.$bvModal.show('modal-center')
          }
          if (this.dataLeads.status === 'VERIFIED') {
            this.$router.push(`/auth-info/${this.dataLeads.leadId}/auth`)
          } else {
            this.checkNoteBeforeAddAction = true
            this.$bvModal.show('modal-center')
          }
        } catch (error) {
          this.showErr(error.response?.data?.message || error.response?.message || error.message)
        }
      },

      acceptAddAction() {
        this.modalBeforeAddAction = false
        this.$bvModal.show('modal-center')
      },

      pushWrongInfo() {
        this.showModalReasonWrongInfo = true
      },
      async submitReasonWrongInfo(event) {
        try {
          const response = await LeadsService.updateWrongInfo({
            leadId: this.dataLeads.leadId,
            reason: event.reasonWrong,
          })
          if (response.code === 1000) {
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = 'Cập nhật thông tin sai thành công !'
            await this.fetchData()
          } else {
            this.showErr(response.message)
          }
        } catch (error) {
          this.showErr(error.response?.data?.message || error.response?.message || error.message)
        } finally {
          this.showModalReasonWrongInfo = false
        }
      },

      showModalAddAction() {
        this.checkNoteBeforeAddAction = false
        this.$bvModal.show('modal-center')
      },

      checkAddAction() {
        if (['WRONG', 'DUPLICATE']?.includes(this.dataAddAction?.result)) {
          this.showModalCheckAction = true
          this.messNoti = `Hệ thống sẽ chuyển Lead thành ${this.dataAddAction === 'WRONG' ? '[Sai thông tin]' : '[Trùng thông tin]'} và bạn không được thao tác gì với Lead này nữa. Bạn có chắc chắn muốn Lưu không?`
        } else {
          this.addAction()
        }
      },

      async addAction() {
        try {
          const isSuccess = await this.$refs.leadAction.validate()
          if (!isSuccess) return

          this.showLoading = true
          this.dataImageToAdd = []
          if (this.dataImages.length > 0) await this.uploadImg()

          this.dataAddAction.exeDate = new Date(this.dataAddAction.exeDate).getTime()

          const today = new Date()
          const currentTime = today.getTime()
          if (this.dataAddAction.exeDate > currentTime) {
            this.showErr('Thời gian thực hiện không đúng, vui lòng chọn lại !')
            return
          }

          const body = {
            action: this.dataAddAction.type,
            leadId: this.leadId,
            exeDate: this.dataAddAction.exeDate,
            note: this.dataAddAction.note,
            result: this.dataAddAction.result,
            actionImgs: this.dataImageToAdd,
          }
          const response = await LeadsService.createAction(body)
          if (response.code === 1000) {
            if (
              ['SUITABLE', 'HAS_SERVICE']?.includes(this.dataAddAction?.result) &&
              (this.paramAction === 'addActionFromOther' || this.checkNoteBeforeAddAction)
            ) {
              this.$router.push(`/auth-info/${this.leadId}/auth`)
              return
            }
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = 'Thêm hoạt động thành công !'
            this.dataAddAction = {}
            this.$bvModal.hide('modal-center')
            await this.fetchData()
          } else {
            this.showErr(response.message)
          }
        } catch (error) {
          this.showErr(error.response?.data?.message || error.response?.message || error.message)
        } finally {
          this.showLoading = false
        }
      },

      showErr(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
        this.msgNoti = message
      },

      cancelAddAction() {
        this.dataAddAction = {}
        this.$bvModal.hide('modal-center')
      },
      async receiveImageToAdd(data) {
        this.dataImages = data
      },
      receiveImageToRemove(index) {
        this.dataImages.splice(index, 1)
      },
      async uploadImg() {
        try {
          for (let index = 0; index < this.dataImages.length; index++) {
            const element = this.dataImages[index]
            await CommonService.uploadImg(element).then(res => {
              if (res.code === 1000) {
                this.dataImageToAdd.push(res.data[0])
              }
            })
          }
        } catch (error) {
          this.showErr(error.response?.data?.message || error.response?.message || error.message)
        }
      },

      showActionImage(item) {
        this.showModalActionsImages = true
        this.dataActionImage = item.actionImgs.length > 0 ? item.actionImgs : []
      },
      isLead(status) {
        return !['MERCHANT', 'POTENTIAL']?.includes(status)
      },
    },
  }
</script>
<style src="./css/font-awesome/css/all.css"></style>
